//src/components/ExpensesExportButton.tsx
import ExportXlsxButton from './ExportXlsxButton';
import { EXPENSES_XLSX_COLUMNS, mapExpenseToRows, getExpenseTime } from '../utils/expensesExport';
import { defaultFilename } from '../utils/filename';

export default function ExpensesExportButton({
  source,
  filename,
  className,
}: { source: any[]; filename?: string; className?: string }) {
 const fn = filename ?? defaultFilename('expenses');

  return (
    <ExportXlsxButton
      source={source}
      filename={fn}
      sheetName="Expenses"
      columns={EXPENSES_XLSX_COLUMNS}
      map={mapExpenseToRows}
      getTime={getExpenseTime}
      className={className}
      title="Экспорт расходов в Excel"
    />
  );
}
